<script setup>
    import Slider from '@vueform/slider'
    import Multiselect from '@vueform/multiselect'

    const { data: quoteBuilder } = await useStatamicGlobals().getGlobal({
        handle: 'quote_builder',
    })

    const store = useStore()

    const kmsPerYearOptions = {}

    for (
        let i = quoteBuilder.value.kms_per_year.lower_amount;
        i <= quoteBuilder.value.kms_per_year.upper_amount;
        i += quoteBuilder.value.kms_per_year.step
    ) {
        kmsPerYearOptions[i] = `${i} km`
    }

    const carMakes = ['All', ...store.carMakes]

    const scrollToCarsList = () => {
        document
            .querySelector('div[name="content"] header')
            .scrollIntoView({ behavior: 'smooth' })
    }
</script>

<template>
    <form
        class="quote-builder-form container relative inset-x-0 lg:fixed lg:bottom-4 lg:z-50 xl:bottom-6 xl:max-w-[1400px]"
    >
        <div
            class="mt-4 flex flex-col gap-5 bg-white lg:mt-0 lg:flex-row lg:items-center lg:justify-between lg:gap-4 lg:rounded-full lg:px-6 lg:py-2.5 xl:gap-10"
        >
            <div
                class="form-title lg:flex-0 flex-1 md:text-xl lg:text-lg xl:text-xl"
            >
                <h3 class="text-lg text-brand2">Step 1:</h3>
                <h2 class="text-lg text-brand1">Get a quote now!</h2>
            </div>

            <label class="flex-1">
                <h4>Your weekly vehicle budget</h4>

                <div class="mb-4 text-xs font-bold text-mid">
                    {{
                        prettyPrice(prettyRoundDown(store.weeklyBudget[0], 50))
                    }}
                    -
                    {{ prettyPrice(store.weeklyBudget[1]) }}
                </div>

                <Slider
                    v-model="store.weeklyBudget"
                    :lazy="false"
                    :min="prettyRoundDown(store.lowestCarPrice / 260, 50)"
                    :max="prettyRoundUp(store.highestCarPrice / 260, 100)"
                    :step="50"
                    :tooltips="false"
                />
            </label>

            <label class="flex-1">
                <h4>Filter by Brand</h4>

                <Multiselect
                    v-model="store.selectedMake"
                    :options="carMakes"
                    :canClear="false"
                    :canDeselect="false"
                    :openDirection="'top'"
                    class="text-sm font-bold text-mid lg:text-xs xl:text-sm"
                />
            </label>

            <PrettyButton
                @click.prevent="scrollToCarsList"
                variant="brand2"
                type="submit"
                class="py-4"
            >
                Find a Car
            </PrettyButton>
        </div>
    </form>
</template>

<style src="@vueform/slider/themes/default.css"></style>
<style src="@vueform/multiselect/themes/default.css"></style>

<style>
    :root {
        --ms-font-size: 0.875rem;
        --ms-option-font-size: 0.875rem;
        --ms-option-line-height: 1.2;
    }
</style>

<style scoped>
    .quote-builder-form > div {
        @screen lg {
            box-shadow: 0px 0px 20px 0px rgba(37, 78, 255, 0.17);
        }
    }

    .quote-builder-form label {
        h4 {
            @apply text-sm font-bold;
        }
    }

    .quote-builder-form .slider-connects {
        overflow: visible;

        .slider-connect {
            top: -3px;
            height: 7px;
        }
    }

    .multiselect {
        border-width: 0 0 1px 0;
        min-height: 40px;

        &.is-active {
            box-shadow: none;
            border-width: 0 0 1px 0;
        }
    }

    small {
        font-size: 0.6em;

        &::before {
            content: '(';
        }

        &::after {
            content: ')';
        }
    }

    .form-title {
        h2,
        h3 {
            font-size: inherit;
            line-height: 1.2;
        }
    }
</style>
